module.exports = __webpack_public_path__ + "img/email.5aba35e6.png";